import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=bb134ecc&scoped=true&"
import script from "./UserCard.vue?vue&type=script&lang=js&"
export * from "./UserCard.vue?vue&type=script&lang=js&"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=bb134ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb134ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb134ecc')) {
      api.createRecord('bb134ecc', component.options)
    } else {
      api.reload('bb134ecc', component.options)
    }
    module.hot.accept("./UserCard.vue?vue&type=template&id=bb134ecc&scoped=true&", function () {
      api.rerender('bb134ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/auth/profile/components/UserCard.vue"
export default component.exports